import type { IconDef } from '../types';

export const upChevron: IconDef = {
  viewBox: '0 0 24 24',
  paths: [
    {
      d: 'M24 17C24 17.26 23.9 17.51 23.7099 17.71C23.3198 18.1 22.6896 18.1 22.2995 17.71L11.9962 7.41L1.70303 17.71C1.31291 18.1 0.682713 18.1 0.292591 17.71C-0.0975305 17.32 -0.0975305 16.69 0.292591 16.3L11.286 5.29C11.4761 5.1 11.7262 5 11.9962 5C12.2663 5 12.5164 5.11 12.7065 5.29L23.7099 16.29C23.91 16.49 24 16.74 24 17Z',
    },
  ],
};
